// extracted by mini-css-extract-plugin
module.exports = {"screenReader":"Text-module__screenReader___29PiG"};